<template>
    <div class="cmd-box">
        <el-row>
            <el-col span="12">
                <el-form ref="form" :model="form"  :inline="true"  label-width="80px" label-position="top">
                    <div>
                        <el-form-item label="设备SN">
                            <el-input v-model="form.sn" size="mini" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="机柜号">
                            <el-input v-model="form.equNo"  size="mini"></el-input>
                        </el-form-item>
                        <el-form-item label="制冷开关">
                            <el-switch
                                    v-model="form.coolSwitch"
                                    active-color="#242C37"
                                    inactive-color="#ff4949"
                                    active-value="0"
                                    inactive-value="1">
                            </el-switch>
<!--                            <el-input v-model="form.coolSwitch"  size="mini"></el-input>-->
                        </el-form-item>
                        <el-form-item label="虚拟温度开关">
                            <el-switch
                                    v-model="form.virtualTempSwitch"
                                    active-color="#242C37"
                                    inactive-color="#ff4949"
                                    active-value="0"
                                    inactive-value="1">
                            </el-switch>
<!--                            <el-input v-model="form.virtualTempSwitch"  size="mini"></el-input>-->
                        </el-form-item>
                        <el-form-item label="虚拟温度">
                            <el-input v-model="form.virtualTemp"  size="mini"></el-input>
                        </el-form-item>
                    </div>


                    <el-form-item>
                        <el-button type="primary" size="mini" @click="handleSubmit('form')">确定</el-button>
                        <el-button size="mini" @click="handleReset('form')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col span="12">
                <div style="padding: 24px">
                    <div v-for="(log,i) in logs" :key="i" style="font-size: 12px;margin-bottom: 12px;word-break: break-word">
                        {{log}}
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "ConfigCoolSwitchBox",
        props: {
            sn: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                form: {
                    sn: '',
                    equNo:'1',
                    coolSwitch:'0',
                    virtualTempSwitch:'0',
                    virtualTemp:'-18',
                },
                logs: [],
                afterTime: '',
                timer: ''
            }
        },
        watch: {
            sn: {
                immediate: true,
                handler() {
                    this.form.sn = this.sn;
                }
            }
        },
        methods: {

            async handleSubmit() {
                this.logs = [];
                clearTimeout(this.timer);
                this.logs.push("正在准备发送指令...");
                await this.loadLog();
                this.timerLoadLog(1000);
                let resp = await this.$http.post(this.$api.$base.root + '/gw/server/configCoolSwitch', Object.assign({reqId: "AT" + new Date().getTime()}, this.form), {headers: {sn: this.sn}});
                if (resp.data.status === 200) {
                    this.logs.push("指令发送完成...");
                } else {
                    this.logs.push("指令发送失败，" + resp.data.desc);
                }
            },
            async loadLog() {
                let resp = await this.$http.post(this.$api.spDevLog.list, this.$qs.stringify({
                    sn: this.sn,
                    asc: true,
                    afterTimeStp: this.afterTime
                }));
                if (!this.afterTime) {
                    this.afterTime = resp.data.time;
                } else {
                    if (resp.data.data.spDevLogs && resp.data.data.spDevLogs.length) {
                        let spDevLogs = resp.data.data.spDevLogs;
                        this.afterTime = spDevLogs[spDevLogs.length - 1].createTime;
                        spDevLogs.forEach((e) => {
                            this.logs.push(e.content);
                        })
                    }
                }
                return;
            },
            async timerLoadLog(time) {
                if (!time) {
                    time = 1000;
                }
                return new Promise(async (res) => {
                    await this.loadLog();
                    this.timer = setTimeout(async () => {
                        res();
                        await this.timerLoadLog(time);
                    }, time);
                })
            },
            handleReset() {
                this.form = {
                    sn: this.sn,
                    equNo:'1',
                    coolSwitch:'0',
                    virtualTempSwitch:'0',
                    virtualTemp:'-18',
                };
            }
        }
    }
</script>

<style scoped>
    .cmd-box {
    }
</style>